<script setup lang="ts">
import type { Option } from '@/js/types/options.ts';
import { classname } from '@/js/utils.js';
import { ref, watch } from 'vue';
import Multiselect from 'vue-multiselect';

const { options, placeholder } = defineProps<{
  options: Option[]
  placeholder?: string
}>();
const value = defineModel();
const option = ref<Option>();
watch(option, (nextOption) => {
  value.value = nextOption?.value;
});
watch(value, (nextValue) => {
  option.value = options.find(item => item.value === nextValue);
}, {
  immediate: true,
});
const cn = classname('base-select');
</script>

<template>
  <div :class="cn()">
    <div v-if="$slots" :class="cn('title')">
      <slot />
    </div>
    <Multiselect v-model="option" label="label" track-by="value" :options :class="cn('control')" :placeholder />
  </div>
</template>

<style lang="scss">
.base-select {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 10px 22px 15px 16px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 2px;

  &__title {
    font-size: 16px;
    color: #c4c4c4;
  }

  .multiselect {
    &__tags {
      padding-left: 0;
      border: none;
    }
  }
}
</style>
